export default "__VITE_ASSET__DoxmfO7i__";